import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "contentFrame" ]
  static values = {
    contentFrameUrl: String
  }

  loadContentFrame(event) {
    if (!this.hasContentFrameUrlValue) return
    if (!this.hasContentFrameTarget) return
    if (!event.target.open) return

    this.contentFrameTarget.src = this.contentFrameUrlValue
  }
}
